module.exports = __webpack_public_path__ + "img/app-icon-8.d7160124.svg";